import { DateTime } from "luxon";

/**
 * If the passed date is in the future, return it.
 * Otherwise, return the current time.
 * @param date
 */
export function dateOrNow(date: Date | string) {
  const dateObj = DateTime.fromJSDate(new Date(date));
  const now = DateTime.now();
  const maxDateTime = DateTime.max(dateObj, now);
  return maxDateTime.toISO();
}
